import { Type } from 'src/components/base/MessagePane';
import { requestStore } from 'src/stores';
import { ConvertIds } from 'src/services/runtime/convertIds'


export async function execute(selection, meta, parentRunnable) {
  const executor = new ConvertIds(selection, meta, parentRunnable);

  executor
    .on('started', (executor) => {
      executor.logger.info('Conversion started');
      requestStore.setText('Conversion started...');
    })
    .on('finished', (executor, result) => {
      const { logger } = executor;
      const { convertedCount } = result;

      if (convertedCount) {
        logger.info(`${convertedCount} IDs were converted`);
        logger.info('Conversion finished');

        requestStore.showPane({
          message: `Conversion was successfully performed`,
          type: Type.Success,
          timeout: 10000,
        });
      }
      else {
        const message = 'There are no 15-character IDs to convert';
        logger.warn(message);

        requestStore.showPane({ message, type: Type.Warning });
      }
    })
    .on('error', (executor, error) => {
      console.log('Conversion error: ', error);
      requestStore.showPane({
        message: `Unable to convert IDs: ${error.message}`,
        type: Type.Error,
      });
    });

  return await executor.run();
}